// VSM site config lives in packages/viewer-services-configs/src/configs/environmentServiceSiteConfig.ts
import { environmentServiceSiteConfig } from '@wix/viewer-services-configs'

const name = 'environmentService'

export const config = { site: environmentServiceSiteConfig, reactNativeSite: environmentServiceSiteConfig, name }
